import BaseService from '_services/rest/base';

class DistributorService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/reseller`;
  }

  getUrlSave(id, url = '/') {
    if (id) {
      return {
        url: `${this.getUrl()}/${url}${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${url}`,
      method: 'POST',
    };
  }

  getDistributorById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search, uf: params.state, status: params.status };

    return this.request(
      `${this.getUrl()}/all/${params.skip}/${params.take}`,
      filters,
    )
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  delete(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE').catch(err => {
      throw err;
    });
  }

  save(distributor) {
    const meta = this.getUrlSave(distributor.id, '');
    return this.request(meta.url, distributor, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getDistributorRegions(params) {
    const filters = {
      group: params.group,
      state: params.state,
      search: params.search,
    };
    return this.request(
      `${this.getUrl()}/regions/${params.id}/${params.skip}/${params.take}`,
      filters,
    ).then(this.handleResponse);
  }

  saveStates({ id, states }) {
    return this.request(
      `${this.getUrl()}/states/${id}`,
      { whole_states: states },
      'PATCH',
    ).catch(err => {
      throw err;
    });
  }

  syncRegions({ id, regions }) {
    return this.request(
      `${this.getUrl()}/regions/${id}`,
      { regions },
      'PUT',
    ).catch(err => {
      throw err;
    });
  }

  toggleStatus(id, status) {
    return this.request(`${this.getUrl()}/status/${id}`, { status }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  toggleDirectSales(id, status) {
    return this.request(`${this.getUrl()}/direct-sales/${id}`, { status }, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getIndicators(id, params) {
    return this.request(`${this.getUrl()}/indicators/${id}`, params)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new DistributorService();
